var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-page",class:{loading: _vm.$store.getters.getLoadOverlay}},[_c('header-menu',{key:"header",attrs:{"id":"main-header","logo":_vm.getLogo(),"logo-height":"40"},on:{"mobile-menu-state":_vm.mobileMenuState}}),_c('router-view',{key:"xxxxxx",attrs:{"id":"main-content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }